import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../providers/auth0-instance";
import { withErrorNotification } from "../notifications";
import { patchCaptureRequest, getCaptureRequest, Capture } from "../../types";

export const captureApi = createApi({
  reducerPath: "captureApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["capture"],
  endpoints: (builder) => ({
    getCapture: builder.query<Capture, getCaptureRequest>({
      query: ({ capture_uuid }) => ({
        url: `/capture/${capture_uuid}`,
        method: "GET",
      }),
      providesTags: ["capture"],
      onQueryStarted: withErrorNotification("Failed to fetch capture"),
    }),
    patchCapture: builder.mutation<Capture, patchCaptureRequest>({
      query: ({ id, data }) => ({
        url: `/capture/${id}`,
        method: "PATCH",
        data,
      }),
      invalidatesTags: ["capture"],
      onQueryStarted: withErrorNotification("Failed to update capture"),
    }),
  }),
});

export const { useGetCaptureQuery, usePatchCaptureMutation } = captureApi;
